import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { MdSpace, Section, SmSpace } from 'm2m.components';
import { NotaComercialApiResponse } from 'common/genericTypes';
import {
  tipoProRataDescriptions,
  indexadorRemuneracaoDescriptions,
  periodicidadeCorrecaoDescriptions,
  tipoProjecaoDescriptions,
  convencaoJurosFixosDescriptions,
  inicioRentabilidadeDescriptions,
} from 'common/genericDescriptions';
import MultaMoraDetailsSection from 'components/instrumentos/registro/criteriosRemuneracao/sections/MultaMoraSection/MultaMoraDetailsSection';
import moment from 'moment';
import { addCpfCnpjMask } from 'utils/mask';
import { formatCurrencyNumber } from 'utils/number';

interface Props {
  criteriosRemuneracao: NotaComercialApiResponse;
  isUsuarioOperacoes: boolean;
  isUsuarioCadastroLeitura: boolean;
  isUsuarioOperacoesLeitura: boolean;
  isUsuarioCadastroOperacoes: boolean;
}

export const DetalhesCriteriosRemuneracao: React.FC<Props> = (props) => {
  const { criteriosRemuneracao, isUsuarioOperacoes, isUsuarioCadastroLeitura, isUsuarioOperacoesLeitura, isUsuarioCadastroOperacoes } = props;

  return (
    <>
      <Section title={'Informações Financeiras'} defaultGrid>
        <div>
          <Typography variant="body2">{'Vol. Nominal Un. de Emissão:'}</Typography>
          <Typography variant="body1">
            {criteriosRemuneracao.criteriosRemuneracao.valorNominalUnitarioEmissao.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 8,
            })}
          </Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Quantidade Emitida:'}</Typography>
          <Typography variant="body1">{criteriosRemuneracao.criteriosRemuneracao.quantidadeEmitida}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Vol. de Emissão:'}</Typography>
          <Typography variant="body1">
            {criteriosRemuneracao.criteriosRemuneracao.volumeEmissao.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Moeda de Emissão:'}</Typography>
          <Typography variant="body1">{criteriosRemuneracao.criteriosRemuneracao.moedaEmissao}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Data Emissão:'}</Typography>
          <Typography variant="body1">
            {moment(criteriosRemuneracao.criteriosRemuneracao.dataEmissao).format('DD/MM/YYYY')}
          </Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Data Vencimento:'}</Typography>
          <Typography variant="body1">
            {moment(criteriosRemuneracao.criteriosRemuneracao.dataVencimento).format('DD/MM/YYYY')}
          </Typography>
          <SmSpace />
        </div>
        {criteriosRemuneracao.criteriosRemuneracao.cotacaoInicial && (
          <div>
            <Typography variant="body2">{'Cotação Inicial:'}</Typography>
            <Typography variant="body1">{criteriosRemuneracao.criteriosRemuneracao.cotacaoInicial}</Typography>
            <SmSpace />
          </div>
        )}
        {criteriosRemuneracao.criteriosRemuneracao.dataInicioRentabilidade && (
          <div>
            <Typography variant="body2">{'Data Início Rentabilidade:'}</Typography>
            <Typography variant="body1">
              {moment(criteriosRemuneracao.criteriosRemuneracao.dataInicioRentabilidade).format('DD/MM/YYYY')}
            </Typography>
            <SmSpace />
          </div>
        )}

        <div>
          <Typography variant="body2">{'Quando será o início da rentabilidade?'}</Typography>
          <Typography variant="body1">
            {inicioRentabilidadeDescriptions[criteriosRemuneracao.criteriosRemuneracao.inicioRentabilidade]}
          </Typography>
          <SmSpace />
        </div>

        {criteriosRemuneracao.criteriosRemuneracao.dataLimiteIntegralizacao && (
          <div>
            <Typography variant="body2">{'Data Limite de Integralização:'}</Typography>
            <Typography variant="body1">
              {moment(criteriosRemuneracao.criteriosRemuneracao.dataLimiteIntegralizacao).format('DD/MM/YYYY')}
            </Typography>
            <SmSpace />
          </div>
        )}

      </Section>
      <Section title={'Remuneração'} defaultGrid>
        <div>
          <Typography variant="body2">{'Indexador:'}</Typography>
          <Typography variant="body1">
            {indexadorRemuneracaoDescriptions[criteriosRemuneracao.criteriosRemuneracao.indexador]}
          </Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Porcentagem Indexador:'}</Typography>
          <Typography variant="body1">
            {criteriosRemuneracao.criteriosRemuneracao.indexadorPorcentagem}
            {' %'}
          </Typography>
          <SmSpace />
        </div>
        {criteriosRemuneracao.criteriosRemuneracao.defasagemFixing && (
          <div>
            <Typography variant="body2">{'Defasagem/Fixing:'}</Typography>
            <Typography variant="body1">{criteriosRemuneracao.criteriosRemuneracao.defasagemFixing}</Typography>
            <SmSpace />
          </div>
        )}
        {criteriosRemuneracao.criteriosRemuneracao.periodicidadeCorrecao && (
          <div>
            <Typography variant="body2">{'Periodicidade de Correção:'}</Typography>
            <Typography variant="body1">
              {periodicidadeCorrecaoDescriptions[criteriosRemuneracao.criteriosRemuneracao.periodicidadeCorrecao]}
            </Typography>
            <SmSpace />
          </div>
        )}
        {criteriosRemuneracao.criteriosRemuneracao.proRata && (
          <div>
            <Typography variant="body2">{'Pro-rata:'}</Typography>
            <Typography variant="body1">
              {tipoProRataDescriptions[criteriosRemuneracao.criteriosRemuneracao.proRata]}
            </Typography>
            <SmSpace />
          </div>
        )}
        {criteriosRemuneracao.criteriosRemuneracao.corrigePeriodoFinal && (
          <div>
            <Typography variant="body2">{'Corrige Período Final?'}</Typography>
            <Typography variant="body1">
              {criteriosRemuneracao.criteriosRemuneracao.corrigePeriodoFinal ? 'Sim' : 'Não'}
            </Typography>
            <SmSpace />
          </div>
        )}
        {criteriosRemuneracao.criteriosRemuneracao.diaAniversario && (
          <div>
            <Typography variant="body2">{'Dia de Aniversário:'}</Typography>
            <Typography variant="body1">{criteriosRemuneracao.criteriosRemuneracao.diaAniversario}</Typography>
            <SmSpace />
          </div>
        )}
        {criteriosRemuneracao.criteriosRemuneracao.mesAniversario && (
          <div>
            <Typography variant="body2">{'Mês Aniversário:'}</Typography>
            <Typography variant="body1">{criteriosRemuneracao.criteriosRemuneracao.mesAniversario}</Typography>
            <SmSpace />
          </div>
        )}
        {criteriosRemuneracao.criteriosRemuneracao.tipoProjecao && (
          <div>
            <Typography variant="body2">{'Tipo de Projeção:'}</Typography>
            <Typography variant="body1">
              {tipoProjecaoDescriptions[criteriosRemuneracao.criteriosRemuneracao.tipoProjecao]}
            </Typography>
            <SmSpace />
          </div>
        )}
        <div>
          <Typography variant="body2">{'Taxa de Juros Fixo/Spread %:'}</Typography>
          <Typography variant="body1">{criteriosRemuneracao.criteriosRemuneracao.taxaJurosFixoSpread}</Typography>
          <SmSpace />
        </div>
        {criteriosRemuneracao.criteriosRemuneracao.convencaoJurosFixos && (
          <div>
            <Typography variant="body2">{'Covenção:'}</Typography>
            <Typography variant="body1">
              {convencaoJurosFixosDescriptions[criteriosRemuneracao.criteriosRemuneracao.convencaoJurosFixos]}
            </Typography>
            <SmSpace />
          </div>
        )}
      </Section>
      
      <MultaMoraDetailsSection
        percentualMulta={criteriosRemuneracao.criteriosRemuneracao?.percentualMulta}
        periodicidadeMulta={criteriosRemuneracao.criteriosRemuneracao?.periodicidadeMulta}
        percentualMora={criteriosRemuneracao.criteriosRemuneracao?.percentualMora}
        periodicidadeMora={criteriosRemuneracao.criteriosRemuneracao?.periodicidadeMora}
      />
      
      {(criteriosRemuneracao.custodiantes !== undefined && criteriosRemuneracao.custodiantes?.length > 0) && (
        <Section title="Investidores">
          {criteriosRemuneracao.custodiantes?.map((custodiante) => (
            custodiante.investidoresPrivados.map((investidor) => {
              return (
                <React.Fragment key={investidor.investidorId}>
                  <Grid container>
                    <Grid item xs={4}>
                      <Typography variant="body2">{'Instituição Custodiante:'}</Typography>
                      <Typography variant="body1">{custodiante.razaoSocialInstituicaoCustodiante}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="body2">{'Investidor:'}</Typography>
                      <Typography variant="body1">{addCpfCnpjMask(investidor.cpfCnpj)}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="body2">{'Quantidade:'}</Typography>
                      <Typography variant="body1">{investidor.quantidade}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="body2">{'Volume Total:'}</Typography>
                      <Typography variant="body1">
                        {(investidor.quantidade * criteriosRemuneracao.criteriosRemuneracao.valorNominalUnitarioEmissao
                        ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="body2">{'Banco:'}</Typography>
                      <Typography variant="body1">{investidor.razaoSocialBanco}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="body2">{'Agência:'}</Typography>
                      <Typography variant="body1">{investidor.agenciaBanco}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="body2">{'Conta:'}</Typography>
                      <Typography variant="body1">{investidor.contaBanco}</Typography>
                    </Grid>
                  </Grid>
                  <MdSpace />
                </React.Fragment>
              )
            })
          ))}
        </Section>
      )}
      {(isUsuarioOperacoes || isUsuarioOperacoes || isUsuarioCadastroLeitura || isUsuarioOperacoesLeitura || isUsuarioCadastroOperacoes) && (
        <Section title={'Custo de Emissão'} defaultGrid>
          <div>
            <Typography variant="body2">{'Custo Total:'}</Typography>
            <Typography variant="body1">
              {formatCurrencyNumber(criteriosRemuneracao.criteriosRemuneracao.custoEmissao?.custoTotal ?? 0)}
            </Typography>
            <SmSpace />
          </div>
          <div>
            <Typography variant="body2">{'Fee Laqus Bruto:'}</Typography>
            <Typography variant="body1">
              {formatCurrencyNumber(criteriosRemuneracao.criteriosRemuneracao.custoEmissao?.feeLaqusBruto ?? 0)}
            </Typography>
            <SmSpace />
          </div>
          <div>
            <Typography variant="body2">{'Fee Laqus Líquido:'}</Typography>
            <Typography variant="body1">
              {formatCurrencyNumber(criteriosRemuneracao.criteriosRemuneracao.custoEmissao?.feeLaqusLiquido ?? 0)}
            </Typography>
            <SmSpace />
          </div>
          <div>
            <Typography variant="body2">{'Fee Repasse:'}</Typography>
            <Typography variant="body1">
              {formatCurrencyNumber(criteriosRemuneracao.criteriosRemuneracao.custoEmissao?.feeRepasse ?? 0)}
            </Typography>
            <SmSpace />
          </div>
        </Section>
      )}
    </>
  );
};
